import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'

// Admin pages
import Overview from 'src/pages/Overview.vue'
import UserProfile from 'src/pages/UserProfile.vue'
import TableList from '@/pages/Agents.vue'
import Typography from 'src/pages/Typography.vue'
import Icons from 'src/pages/Icons.vue'
import Maps from 'src/pages/Maps.vue'
import Notifications from 'src/pages/Notifications.vue'
import Upgrade from 'src/pages/Upgrade.vue'
import Login from "@/pages/Login.vue";
import Agents from "@/pages/Agents.vue";
import Callback from "@/pages/Callback.vue";
import Services from "@/pages/Services.vue";
import Users from "@/pages/Users.vue";
import ServiceAccess from "@/pages/ServiceAccess.vue";
import Audit from "@/pages/Audit.vue";
import SignIn from "@/pages/SignIn.vue";
import Register from "@/pages/Register.vue";
import Settings from "@/pages/Settings.vue";
import Resources from "@/pages/Resources.vue";
import Traces from "@/pages/Traces.vue";
import AppCallback from "@/pages/AppCallback.vue";
import Network from "@/pages/Network.vue";

const routes = [


  {
    path: '/',
    component: DashboardLayout,
    redirect: '/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'users',
        name: 'Users',
        component: Users
      },
      {
        path: 'agents',
        name: 'Agents',
        component: Agents
      },
      {
        path: 'services',
        name: 'Services',
        component: Services
      },
      {
        path: 'roles',
        name: 'Resources',
        component: Resources
      },
      {
        path: 'access',
        name: 'Access',
        component: ServiceAccess
      },
      {
        path: '/account',
        name: 'Account',
        component: UserProfile
      },
      {
        path: '/settings',
        name: 'Settings',
        component: Settings
      },
      {
        path: '/audit',
        name: 'Audit',
        component: Audit
      },
      {
        path: '/logs',
        name: 'Logs',
        component: Traces
      },
      {
        path: 'maps',
        name: 'Maps',
        component: Maps
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: Notifications
      },
      {
        path: 'network',
        name: 'Network',
        component: Network
      },
      {
        path: 'upgrade',
        name: 'Upgrade to PRO',
        component: Upgrade
      }
    ]
  },
  {
    path: '/login',
    component: Login,
    name: 'Login',
    meta: {requiresHistoryMode: true},
  },
  {
    path: '/callback',
    component: Callback,
    name: 'Callback',
    meta: {requiresHistoryMode: true},
  },
  {
    path: '/callback-app',
    component: AppCallback,
    name: 'AppCallback',
    meta: {requiresHistoryMode: true},
  },
  {
    path: '/register',
    component: Register,
    name: 'Register',
    meta: {requiresHistoryMode: true},
  },
  {
    path: '/sign-in',
    component: SignIn,
    name: 'SignIn',
    meta: {requiresHistoryMode: true},
  },
  {path: '*', component: NotFound}
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
 var res= require('../components/Dashboard/Views/' + name + '.vue');
 return res;
 };**/



export default routes
